import React from 'react' 
import styled from 'styled-components'
import { Col } from 'react-bootstrap'
import { BsCloudDownloadFill } from "react-icons/bs";
import TextS1st2911 from '../../../../components/text/TextS1st2911'
import VideoPlayer from '../../../../components/videoPlayer';
import { headlineStyle } from '../../../../Styles/styledComponents/sidebar';


export const DeviceDetails = () => {
  return (
    <DeviceDetailsDiv>
        <Col className='d-flex  align-items-center justify-content-between'>
        <TextS1st2911 data={{text:"Download facility layout",customStyle: headlineStyle}}/>
        <BsCloudDownloadFill className="downloadIcon" />
        </Col>
        <Col>
        <TextS1st2911
        data={{ text: "Time of incident", customStyle: headlineStyle }}
      />
       <TextS1st2911
        data={{ text: "Address", customStyle: headlineStyle }}
      />
     
        </Col>
        <VideoPlayer/>
        <TextS1st2911
        data={{ text: "Additional Info", customStyle: headlineStyle }}
      />
    </DeviceDetailsDiv>
  )
}

const DeviceDetailsDiv = styled.div`
    width:100%;
    display:flex;
    flex-direction:column;
    align-items:flex-start;
    justify-content:center;
`